import styled from 'styled-components';
import { BasketSelectSectionStyled } from '../BasketRentPaymentSelectionStyled';
import { rem } from 'polished';

export const BasketRentPaymentSelectionAP = styled(BasketSelectSectionStyled)`
    .section {
        .description,
        .primaryText {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
        }

        .summary {
            .otherPrices {
                .otherPrice {
                    font-size: ${({ theme }) => theme.fontSizes.textBase};
                }
            }
        }
    }
`;
